import {
  ReactSelectPlaceholder,
  ReactSelectStyles,
} from "@/consts/ReactSelect";
import useAllUseTypes from "@/hooks/useAllUseTypes";
import useExistBuildingType from "@/hooks/useExistBuildingTypes";
import useFindEntityById from "@/hooks/useFindEntityById";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { FC, useCallback } from "react";
import ReactSelect from "react-select";
import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import MultiSelect from "@/components/MultiSelect";
import NavigationSection from "@/components/NavigationSection";
import NavigationSectionConstructionType from "@/components/NavigationSectionConstructionType";
import NavigationSectionFloorSpace from "@/components/NavigationSectionFloorSpace";
import NavigationSectionStructureType from "@/components/NavigationSectionStructureType";
import SearchBarMini from "@/components/SearchBarMini";

interface Props {
  buildingTypeId?: number;
  query: ArchitectureSearchQueryParameter;
  queryController: SearchQueryParameterController<ArchitectureSearchQueryParameter>;
}

const NavigationArchitectureSidebar: FC<Props> = ({
  buildingTypeId,
  query,
  queryController,
}): JSX.Element => {
  const existBuildingTypes = useExistBuildingType();
  const { addQuery, submitQuery } = queryController;

  const buildingTypeSelectChangeHandler = useCallback(
    (selected) => {
      queryController.addQuery("building_type_id", selected.value.toString());
      queryController.submitQuery();
    },
    [queryController],
  );

  const allUseTypes = useAllUseTypes();
  const selectedUseType = useFindEntityById(allUseTypes, query.use_type_id);

  return (
    <nav className="w-200 tracking-widest laptop:block hidden pt-8">
      <div className="space-y-24">
        <SearchBarMini
          onSubmited={(keyword: string) => {
            addQuery("keyword", keyword);
            submitQuery();
          }}
          placeholder="建物や家具の名前で検索してみよう。"
        />

        <NavigationSection title={`建築の種類`} expandable={false}>
          <MultiSelect
            instanceId="building_type"
            existEntities={existBuildingTypes}
            onChange={buildingTypeSelectChangeHandler}
            selectedId={buildingTypeId}
          />
        </NavigationSection>

        <NavigationSection title={"空間用途"} expandable={false}>
          <ReactSelect
            instanceId={"use_type_id"}
            options={allUseTypes.map((p) => {
              return { label: p.name, value: p.id };
            })}
            onChange={(opt) => {
              queryController.addQuery("use_type_id", opt.value.toString());
              queryController.submitQuery();
            }}
            value={
              selectedUseType
                ? { value: selectedUseType.id, label: selectedUseType.name }
                : null
            }
            styles={ReactSelectStyles}
            placeholder={ReactSelectPlaceholder}
          />
        </NavigationSection>

        <NavigationSectionConstructionType
          query={query}
          queryController={queryController}
        />
        <NavigationSectionStructureType
          query={query}
          queryController={queryController}
        />
        <NavigationSectionFloorSpace
          query={query}
          queryController={queryController}
        />
      </div>
    </nav>
  );
};
export default NavigationArchitectureSidebar;
